import { nanoid } from 'nanoid';

import { WorkflowNodeType } from '../constants';
import { FlowNodeRegistry } from '../../typings';
import iconFeishuSheet from '../../assets/icon-link.png';
import { formMeta } from './feishu-sheet-meta';

// 定义推送飞书表节点注册信息
const FeishuSheetNodeRegistry: FlowNodeRegistry = {
  type: WorkflowNodeType.FeishuSheet,
  label: '推送飞书表',
  meta: {},
  info: {
    icon: iconFeishuSheet,
    description: '推送数据到飞书表',
  },
  formMeta,
  onAdd(ctx) {
    return {
      id: `${WorkflowNodeType.FeishuSheet}_${nanoid(5)}`,
      type: WorkflowNodeType.FeishuSheet,
      data: {
        title: '推送飞书表',
      },
    };
  },
};

export { FeishuSheetNodeRegistry };
